import React from 'react';
import { Content_File, CollegeIncomingChatBubbleFragment } from '../../../../generated/spin-graphql';
import { PictureWithFallback } from '../../../sections/PictureWithFallback';
import { MessageContainer } from '../MessageContainer';
import { gql } from '@urql/core';

type Props = {
    picture?: Partial<Content_File>;
    message: CollegeIncomingChatBubbleFragment;
};

gql`
    fragment CollegeIncomingChatBubble on espin_message {
        ...MessageContainer
        player_user {
            player_profile {
                first_name
                last_name
            }
            deleted_at
        }
        high_school {
            name
            profile_pic_file {
                ...SpinContentImageDisplay
            }
        }
    }
`;

function getIncomingChatAuthor(message: CollegeIncomingChatBubbleFragment) {
    if (message.player_user) {
        return `${message.player_user?.player_profile?.first_name} ${message.player_user?.player_profile?.last_name}`;
    } else if (message.high_school) {
        return message.high_school.name;
    }
    return 'Deleted User';
}

export const CollegeIncomingChatBubble: React.FC<Props> = ({ picture, message }) => {
    const author = getIncomingChatAuthor(message);
    return (
        <div className="chat-bubble">
            <div className="image-wrapper">
                <PictureWithFallback width={40} height={40} icon={picture} alt={`${author}'s profile image`} />
            </div>
            <MessageContainer message={message} />
        </div>
    );
};
